import React from 'react';
import './GiveUpButton.css';
import FlagIcon from '@mui/icons-material/Flag';

const GiveUpButton = ({ onGiveUp, isComplete }) => {
  return (
    <button
      className="give-up-button"
      onClick={onGiveUp}
      aria-label="Give up"
      disabled={isComplete}
    >
      <FlagIcon sx={{ fontSize: 20 }} />
    </button>
  );
};

export default GiveUpButton;

